<template>
  <table class="cart-items">
    <thead>
    <tr>
      <th>
        <div class="heading-primary">{{ $t('common.overview') }}</div>
      </th>
      <th>{{ $t('my_account.orders.amount') }}</th>
      <th>{{ $t('my_account.orders.price') }}</th>
      <th>{{ $t('my_account.orders.subtotal') }}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="item in items" :key="item.id">
      <td>
        <div class="item-holder">
          <div class="image">
            <img :src="getItemImage(item)" alt="" >
          </div>
          <div class="item-info">
            <div class="brand">{{ item.product.brand.name }}</div>
            <div class="name">{{ item.product.name }}</div>
            <span v-if="item.deal_type" class="beauty-deal-label">{{ item.deal_type }}</span>
            <div>{{ item.product.size }}</div>
          </div>
        </div>
      </td>
      <td>
        <div class="quantity-holder">
          <button
              type="button"
              class="btn-inc"
              v-if="item.allow_quantity"
              :disabled="item.quantity === 1"
              @click.prevent="() => updateCartItemQuantity({ id: item.id, option: { amount: item.quantity - 1 } })"
          >-</button>
          <div class="quantity highlight">{{ item.quantity }}</div>
          <button
              type="button"
              class="btn-dec"
              v-if="item.allow_quantity"
              :disabled="item.quantity === item.max_quantity"
              @click.prevent="() => updateCartItemQuantity({ id: item.id, option: { amount: item.quantity + 1 } })"
          >+</button>
        </div>
      </td>
      <td>
        <div class="highlight" :class="{ 'sale-category' :item.product.is_sale }">{{ item.product.price }}</div>
      </td>
      <td>
        <div class="highlight" :class="{ 'sale-category' :item.product.is_sale }">{{ item.total }}</div>
      </td>
    </tr>
    </tbody>
  </table>
</template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { useCart } from "@/app/Checkout/composables/useCart"
import { getItemImage } from '@/helper'

const { items, deleteCartItem, updateCartItemQuantity } = useCart()
</script>
